import { UserBooking } from "../../types/responseTypes";

async function getBookingStep(booking: UserBooking): Promise<number> {
  try {

    /* 
    if (booking.bookingId === "f452771f-511a-4028-8491-bf552bc83083") {
      return 0
    } else if (booking.bookingId === "31959d76-2511-4715-9bb4-39914230fca5") {
      return 1
    } else if (booking.bookingId === "44e6ec69-8a73-408f-adda-efe764483ad0") {
      return 2 // HomePostInstalation
    } else if (booking.bookingId === "4b2e765e-29a0-4f5d-bf63-bc7265844d7a") {
      retrun 3 
    } else if (booking.bookingId === "11111115") {
      return 4
    } else if (booking.bookingId === "11111116") {
      return 5
    } else if (booking.bookingId === "7c51683d-c7ed-46a7-bca8-f4478b13ffa6") {
      return 6; // Pending2nd
      return 5; // HomePostTermino
      return 7; // HomePostPaneles
      return 8; // HomeEntreVisitaInstall
    }

    else if (!booking.hasContractDocument && !booking.installationCompeted) {
      return 0;
    } else if (booking.hasContractDocument && !booking.installationCompeted) {
      return 1;
    } else if (booking.hasContractDocument && booking.installationCompeted) {
      return 2;
    }

    console.log(`booking.bookingId: ${booking.bookingId} | step: ${step}`);

    return step;
    */
    if (booking.bookingId === "03588526-05c7-4a1d-95af-e7f833f45ed8") {
      // piri: bdo ohiggins 340
      return 0;
    } else if (booking.bookingId === "529588bb-f607-4980-ac7a-2748bff6a50b") {
      // piri: vña mackenna 4860
      return 1;
    } else if (booking.bookingId === "70f6fe42-df3b-4523-a04e-96f18be52870") {
      // piri: av grecia 2001
      return 2; // HomePostInstalation
    } else if (booking.bookingId === "347e36e6-5216-497a-9ce0-ed235135313a") {
      // piri: gral san martin 665
      return 3;
    } else if (booking.bookingId === "775a5dc4-0c8c-475b-a8f0-30d9d52b1d7e") {
      // piri: moneda 1202
      return 4;
    } else if (booking.bookingId === "0e50d457-1f42-4118-8a7a-d7eb9d45d9c3") {
      // piri: jguz 3300
      return 5;
    //} //else if (booking.bookingId === "7c51683d-c7ed-46a7-bca8-f4478b13ffa6") {
      //return 5; // HomePostTermino
      //return 6; // Pending2nd
      //return 7; // HomePostPaneles
      //return 8; // HomeEntreVisitaInstall
    } else {
      const url = `https://ruuf-backend.online/booking/get-booking-step/${booking.bookingId}`;
      const timeout = new Promise<Response>((_, reject) =>
        setTimeout(() => reject(new Error("Request timed out")), 10000),
      );
      const response = await Promise.race([
        fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }),
        timeout,
      ]);

      if (!(response instanceof Response)) {
        throw response;
      }
      if (response.status === 200) {
        // console.log("response: ", response);
        const step = await response.json();
        console.log("Booking step fetched successfully: ", step.status);
        return step.status;
      } else {
        throw new Error("Could not fetch booking step");
      }
    }
  } catch (error) {
    console.error("Error fetching user bookings:", error);
    return -1;
  }
}

export default getBookingStep;
